<template>
<Header hrefTo="#mainView"/>
<Main heading="Accessibility Statement">
  <main-view :isContactPage="true">
<h2>Accessibility Statement for <span class="basic-information website-name">ICRT Website</span></h2>
<p>
	This is an accessibility statement from <span class="basic-information organization-name">International Consumer Research and Testing</span>.
</p>
<h3>Conformance status</h3>
<p>
The <a href="https://www.w3.org/WAI/standards-guidelines/wcag/">Web Content Accessibility Guidelines (WCAG)</a>  defines requirements for designers and developers to improve accessibility for people with disabilities. It defines three levels of conformance: Level A, Level AA and Level AAA. This Website has been designed to be fully conformant with WCAG 2.1 level AA. Fully conformant means that the content fully conforms to the accessibility standard without any exceptions.
	<span>ICRT Website</span>
	is
	<span>fully conformant</span>
	with
	<span><span data-negate="">WCAG 2.1 level AA</span>.</span>
	<span>
	<span>Fully conformant</span>
	means that
	<span>the content fully conforms to the accessibility standard without any exceptions</span>.
</span>
</p>
<h3>Feedback</h3>
<p>
	We welcome your feedback on the accessibility of
	<span>ICRT Website</span>.
	Please let us know if you encounter accessibility barriers on
	<span>ICRT Website</span>:
</p>
<ul class="pages-ul">
	<li>
	Call us 
	<span>on + 44(0) 207 563 9170</span>
</li>
	<li>
	Send e-mail
	<a href="mailto:helpdesk@international-testing.orghelpdesk@international-testing.org">to helpdesk@international-testing.org</a>
</li>
	<li>
	Visitor Address:
	<span> 24 Highbury Crescent, London, N5 1RX</span>
</li>
	<li>
	Postal Address:
	<span> 24 Highbury Crescent, London, N5 1RX</span>
</li>
</ul>
<p>
	We try to respond to feedback within <span class="feedback responsetime">2 business days</span>.
</p>
<h3>Date</h3>
<p>
	This statement was created on
	<span class="basic-information statement-created-date">30 September 2021</span>
	using the <a href="https://www.w3.org/WAI/planning/statements/">W3C Accessibility Statement Generator Tool</a>.
</p>
  </main-view>
</Main>
<Footer :isHomePage="true" />
</template>

<script>
import { useGtag } from "vue-gtag-next";
import Header from "../../components/Header/_Header.vue";
import Main from "../../components/Main/_Main.vue";
import MainView from "../../components/MainView/_MainView.vue"
import Footer from "../../components/Footer/_Footer";
import CookiesMesage from "../../components/Cookies/_CookiesMessage.vue";

export default {
  name: "Accessibility",
  components: {
    Header,
    Main,
    MainView,
    Footer,
		CookiesMesage
  },
};
</script>

<style lang="scss">
  @import "./accessibility.scss";
</style>
